import ThumbnailCard from "@components/Blocks/Card/Thumbnail/ThumbnailCard";
import AdsContainer from "@components/Blocks/Container/AdsContainer";
import SubSectionNav from "@components/Blocks/SubSectionNav/SubSectionNav";
import LoadMore from "@components/Modules/LoadMore/LoadMore";
import { CompanionAdsLb } from "@elements/Advertisement/variant/CompanionAdsLb";
import AudioPlayer from "@elements/Player/PodcastPlayer";
import { SectionTitleV2 } from "@elements/Typography/TitleV2";
import { displayAfter, isArrayWithElements } from "@helper/utils";
import WidgetWrapper from "@routes/Home/HomePageLayout/WidgetWrapper";
import { type PodcastProcessedResponse } from "@transformer/usePodcastResponse";
import { PageAdTargetValue } from "@typings/Ads.d";
import { ReactNode } from "react";

type PodcastNewProps = {
  playing: PodcastProcessedResponse | undefined;
  podcasts: PodcastProcessedResponse[] | undefined;
  sectionName: string;
  pageAdTargetValue: PageAdTargetValue;
  handleOnClickThumbnail: (props: PodcastProcessedResponse) => void;
  handleLoadMorePodcasts: () => Promise<number>;
};

const PAGE_SIZE = 8;

export default function PodcastNew(props: PodcastNewProps) {
  const {
    playing,
    podcasts,
    sectionName,
    pageAdTargetValue,
    handleOnClickThumbnail,
    handleLoadMorePodcasts,
  } = props;

  const displaySectionName = "Multimedia";

  return (
    <>
      <WidgetWrapper>
        <SectionTitleV2 sectionName={displaySectionName} />
        <SubSectionNav
          sectionName={sectionName}
          displaySection={displaySectionName}
        />
      </WidgetWrapper>
      {playing && <AudioPlayer {...playing} height="200" audioSticky={true} />}
      {isArrayWithElements(podcasts) &&
        podcasts.reduce((acc: ReactNode[], _, index) => {
          // Insert an ad every PAGE_SIZE articles, outside the wrapper
          if (displayAfter(index, PAGE_SIZE)) {
            acc.push(
              <AdsContainer key={`ad-${index}`}>
                <CompanionAdsLb
                  uniqueSectionName={sectionName}
                  index={index / PAGE_SIZE}
                  pageAdTargetType={pageAdTargetValue}
                  stripeBackground={false}
                  overRideSlot={false}
                  applySizeMapping={true}
                />
              </AdsContainer>,
            );
          }
          // Start a new batch every 8 articles
          if (index % PAGE_SIZE === 0) {
            acc.push(
              <WidgetWrapper key={`batch-${index}`} className="my-[20px]">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                  {podcasts
                    .slice(index, index + PAGE_SIZE)
                    .map((podcast, idx) => (
                      <ThumbnailCard<PodcastProcessedResponse>
                        variant="podcast"
                        key={`podcast-${index}-${idx}`}
                        handleOnClickThumbnail={handleOnClickThumbnail}
                        {...podcast}
                      />
                    ))}
                </div>
              </WidgetWrapper>,
            );
          }

          return acc;
        }, [])}
      <div className="my-md">
        <LoadMore
          onLoadMore={handleLoadMorePodcasts}
          loadText="Laporan lain podcasts"
          virtualPVTitle="Podcast"
          pageNumber={1}
        />
      </div>
    </>
  );
}
